(function () {
    'use strict';

    angular
        .module('app.shipmentProvider')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'shipmentProvider',
                config: {
                    url: '/shipmentProvider',
                    title: 'Kargo',
                    abstract: true,
                    templateUrl: 'app/shipment/shipmentProvider.html'
                }
            },
            {
                state: 'shipmentProvider.list',
                config: {
                    templateUrl: 'app/shipment/shipmentProvider.list.html',
                    controller: 'ShipmentProviderListController',
                    controllerAs: 'vm',
                    url: '/list',
                    title: 'Kargo Firma Listesi',
                    settings: {
                        nav: 20,
                        name: 'shipmentProvider.list',
                        topName: 'sales',
                        content: 'Kargo Firma Listesi',
                        resource: 'menu.shipmentProvider.list'
                    }
                }
            },
            {
                state: 'shipmentProvider.add',
                config: {
                    templateUrl: 'app/shipment/shipmentProvider.add.html',
                    controller: 'ShipmentProviderAddController',
                    controllerAs: 'vm',
                    url: '/add',
                    title: 'Kargo Firma Ekle',
                    settings: {
                        nav: 10,
                        name: 'shipmentProvider.add',
                        content: 'Kargo Firma Ekle',
                        resource: 'menu.shipmentProvider.add'
                    }
                }
            }
        ];
    }
})();